import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from 'shared/material.module';


import { SidebarComponent } from './sidebar/sidebar.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';


import { AppPipesModule } from '@solar/_directives';
import { BaseComponentsModule, DialogsModule } from 'basecomponents';
import { MessagebarModule } from 'basecomponents';


import { FileUploadModule, UPLOAD_SERVICE_CONFIG_TOKEN } from 'guploadmgr';
import { SolarComponentsModule } from 'solar-components';
import { FrTabModule } from './maintab/frtabmodule.module';
import { NavBarModule } from './navbar/navbar.module';
import { ListFilterComponent } from './list-filter/list-filter.component';
import { DialogUploadComponent } from './uploadDialog/dialog-upload.component';
import { CoordsComponent } from './coords/coords.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FileChooserComponent } from './file-chooser/file-chooser.component';
import { UploadSimpleFileComponent } from './upload-simple-file/upload-simple-file.component';
import { SliderDlgModule } from './sliderdlg/sliderdlg.module';



@NgModule({
  imports: [
    CommonModule
    , FormsModule
    , ReactiveFormsModule
    , RouterModule
    , MaterialModule
    , CKEditorModule
    , BsDropdownModule
    , AppPipesModule
    , BaseComponentsModule
    , PerfectScrollbarModule
    , MessagebarModule
    , DialogsModule
    , FileUploadModule
    , NavBarModule
    ,SliderDlgModule
    ,SolarComponentsModule
    ,FrTabModule
    ,NavBarModule
  ],
  declarations: [
    SidebarComponent
    ,ListFilterComponent
    ,DialogUploadComponent
    ,CoordsComponent
    ,FileChooserComponent
    , UploadSimpleFileComponent


  ],
  entryComponents: []
  ,
  exports: [
    CommonModule
    , FormsModule
    , ReactiveFormsModule
    , RouterModule
    , MaterialModule
    , PerfectScrollbarModule
    , CKEditorModule
    , BsDropdownModule
    , AppPipesModule
    , BaseComponentsModule
    , CoordsComponent    
    , DialogsModule
    , FileUploadModule
    ,FrTabModule
    , NavBarModule
    , MessagebarModule    
    ,SolarComponentsModule
    ,SidebarComponent
    ,SliderDlgModule
    ,ListFilterComponent
    ,CoordsComponent
    ,FileChooserComponent
    ,UploadSimpleFileComponent
  ]
  ,providers:[
/*     { provide: 'AuthenticationProvider', useClass: AuthenticationService} 
    ,{provide: UPLOAD_SERVICE_CONFIG_TOKEN, useValue: environment.API_UPLOAD_ENDPOINT}  */
  ]
})
export class ComponentsModule {
  static forRoot(): ModuleWithProviders<ComponentsModule> {
    return {
      ngModule: ComponentsModule,
      providers: [
        
      ]
    };
  }
}
